function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgSworddd = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 511.999 511.999",
  style: {
    enableBackground: "new 0 0 511.999 511.999"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#BF6015"
  },
  points: "159.099,395.326 84.853,469.573 42.426,469.573 42.426,427.146 116.673,352.9 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#994C10"
  },
  points: "159.099,395.326 84.853,469.573 42.426,469.573 137.886,374.113 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#E5E5E5"
  },
  d: "M490.722,165.527l21.213-148.492c0.425-4.669-1.273-9.334-4.455-12.516s-7.848-4.88-12.516-4.455 L346.472,21.277c-3.817,0.425-7.212,2.545-9.545,5.303L126.219,279.714c-4.879,6.153-4.455,14.637,1.06,20.153l84.853,84.853 c5.516,5.516,14,5.939,20.153,1.06l253.134-210.708C488.177,172.739,490.298,169.344,490.722,165.527z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#C8C6CD"
  },
  d: "M485.419,175.072L232.285,385.78c-6.153,4.879-14.637,4.455-20.153-1.06l-42.426-42.426L507.48,4.519 c3.182,3.182,4.88,7.847,4.455,12.516l-21.213,148.492C490.298,169.344,488.177,172.739,485.419,175.072z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#AEADB3"
  },
  d: "M380.413,152.799L190.919,342.293c-5.939,5.939-15.273,5.94-21.213,0s-5.939-15.274,0-21.213 L359.2,131.586c5.94-5.94,15.273-5.94,21.213,0C386.354,137.526,386.354,146.858,380.413,152.799z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#8B8892"
  },
  d: "M169.706,342.293l210.708-210.708c5.94,5.94,5.94,15.273,0,21.213L190.919,342.293 C184.98,348.232,175.646,348.234,169.706,342.293z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#57555C"
  },
  d: "M233.345,363.507l-84.853-84.853c-17.607-17.607-46.032-17.607-63.64,0L63.64,299.867 c-5.939,5.939-5.94,15.273,0,21.213l127.279,127.279c5.94,5.94,15.274,5.939,21.213,0l21.213-21.213 C250.953,409.539,250.953,381.114,233.345,363.507z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#3C3A41"
  },
  d: "M233.345,427.146l-21.213,21.213c-5.939,5.939-15.273,5.94-21.213,0l-63.64-63.64l63.64-63.64 l42.426,42.426C250.953,381.114,250.953,409.539,233.345,427.146z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#57555C"
  },
  d: "M54.73,511.998l-24.606,0.001c-8.061,0-15.485-3.182-21.213-8.91C3.182,497.361,0,489.936,0,481.875 l0.001-24.607C0,440.723,13.577,427.146,30.124,427.146h12.303l42.426,42.426v12.303C84.853,498.422,71.276,511.999,54.73,511.998z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#3C3A41"
  },
  d: "M84.853,481.875c0,16.547-13.577,30.124-30.122,30.122l-24.607,0.002 c-8.061,0-15.485-3.182-21.213-8.91l54.729-54.73l21.213,21.213V481.875z"
}), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSworddd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sworddd.e93e55c3.svg";
export { ForwardRef as ReactComponent };